const articles = [
    [ '' ],
    [ 'ein' ],
    [ '' ],
    [
        'mein',
        'dein',
        'sein',
        'ihr',
        'unser',
        'euer',
        'Ihr'
    ],
];

export default articles;


/** WEBPACK FOOTER **
 ** ./tables/articles/roots/data.js
 **/